var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex CenterTopContainer"},[_c('AccumulateTip',{attrs:{"width":66,"label":"体育场地设施数量","count":7366789,"labelWidth":100,"countMargin":14,"unit":"个"}}),_c('AccumulateTip',{attrs:{"width":66,"label":"体育场地总面积","count":7366789,"labelWidth":100,"countMargin":14,"unit":"㎡"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }